import styled from 'styled-components';

export const SearchContainer = styled.div`
    display: flex;
    align-items: flex-start;
    width: 100%;
    
    & button {
        margin-left: 25px;
    }

    & > div {
        margin: 0; 
        width: 404px; 
    }

    @media (max-width: 900px) {
        flex-direction: column;
        margin: 0;

        & div,
        & button {
            width: 100%;
        }

        & button {
            margin: 10px 0;
            margin-bottom: 25px;
        }

        & input {
            width: 100%;
        }
    }
`;
